import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SelectableOption } from '../filter.component';
import { TranslatePipe } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { FilterOptionComponent } from '../../filter-option/filter-option.component';

@Component({
  selector: 'app-filter-measurement',
  templateUrl: './filter-measurement.component.html',
  styleUrls: ['./filter-measurement.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FilterOptionComponent, MatRadioModule, FormsModule, TranslatePipe],
})
export class FilterMeasurementComponent implements OnInit {
  @Input() measurementOptions: SelectableOption[] = [];

  @Output() apply = new EventEmitter();
  @Output() back = new EventEmitter();
  @Output() optionChange: EventEmitter<SelectableOption> = new EventEmitter<SelectableOption>();

  currentSelectedStateFilter = '';

  ngOnInit(): void {
    const selectedOption = this.measurementOptions.find((option) => option.isSelected);

    if (selectedOption) {
      this.currentSelectedStateFilter = selectedOption.value;
    }
  }

  onApply() {
    this.apply.emit();
  }

  onBack() {
    this.back.emit();
  }

  onOptionChange(option: SelectableOption) {
    this.optionChange.emit(option);
  }
}
